import Spinner from '.';

const SpinnerListBottom = () => (
  <div className='flex h-20 items-center justify-center'>
    <Spinner />
  </div>
);

export default SpinnerListBottom;
